<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
<!--        <a-row>-->
<!--          <a-col :span="24">-->
            <a-form-model-item :label="language['legalperson.code']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="legalpersonCode">
              <a-input v-model="model.legalpersonCode" :placeholder="language['common.pleaseInput']+language['legalperson.code']" :disabled="formDisabled" ></a-input>
            </a-form-model-item>
<!--          </a-col>
          <a-col :span="24">-->
            <a-form-model-item :label="language['legalperson.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="legalpersonName">
              <a-input v-model="model.legalpersonName" :placeholder="language['common.pleaseInput']+language['legalperson.name']" :disabled="formDisabled" style="width: 85%"></a-input>
              <a-button @click="languageModelOpen('EpBdPerson','legalpersonName',nameLanguages,)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>

            <a-form-model-item :label="language['legalperson.legalpersonPerson']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="legalpersonPerson">
              <a-input v-model="model.legalpersonPerson" :placeholder="language['common.pleaseInput']+language['legalperson.legalpersonPerson']" :disabled="formDisabled" style="width: 85%"></a-input>
              <a-button @click="languageModelOpen('EpBdPerson','legalpersonPerson',legalpersonPersonLanguages,)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>
            <a-form-model-item :label="language['legalperson.address']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="address">
              <a-input v-model="model.address" :placeholder="language['common.pleaseInput']+language['legalperson.address']" :disabled="formDisabled" style="width: 85%"></a-input>
              <a-button @click="languageModelOpen('EpBdPerson','address',addressLanguages,)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>
        <a-form-model-item :label="language['legalperson.socialCreditCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="socialCreditCode">
          <a-input v-model="model.socialCreditCode"  :disabled="formDisabled" ></a-input>
        </a-form-model-item>
            <a-form-model-item :label="language['legalperson.phone']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="phone">
              <a-input v-model="model.phone" :placeholder="language['common.pleaseInput']+language['legalperson.phone']" :disabled="formDisabled" ></a-input>
            </a-form-model-item>
            <a-form-model-item :label="language['legalperson.telephone']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="telephone">
              <a-input v-model="model.telephone" :placeholder="language['common.pleaseInput']+language['legalperson.telephone']" :disabled="formDisabled" ></a-input>
            </a-form-model-item>
            <a-form-model-item :label="language['basedata.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-input v-model="model.remark" :placeholder="language['common.pleaseInput']+language['basedata.remark']"  :disabled="formDisabled"></a-input>
            </a-form-model-item>
<!--        </a-row>-->
      </a-form-model>
      <language-model ref="languageModel" @ok="languageOk"></language-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import LanguageModel from "@/components/LanguageModel"
  import { duplicateCheck } from '@/api/api'

  export default {
    name: 'EpFactoryForm',
    components: {
      LanguageModel,
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,

        url: {
          add: "/sys/epPerson/add",
          edit: "/sys/epPerson/edit",
          queryById: "/sys/epPerson/queryById"
        },
        nameLanguages:[],
        legalpersonPersonLanguages:[],
        addressLanguages:[],
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules() {
        if (this.language) {
          return {
            legalpersonCode: [
              { required: true, message: this.language['common.pleaseInput']+this.language['legalperson.code']},
              { validator: (rule, value, callback) => validateDuplicateValue('ep_bd_legalperson', 'legalperson_code', value, this.model.id,'0', callback)},
              {max: 50, message:  this.language['common.lengthUnder']  + '50', trigger: 'blur'}
            ],
            legalpersonName: [
              { required: true, message:this.language['common.pleaseInput']+this.language['legalperson.name']},
              { validator: (rule, value, callback) => validateDuplicateValue('ep_bd_legalperson', 'legalperson_name', value, this.model.id,'0', callback)},
              {max: 200, message: this.language['common.lengthUnder']  + '200', trigger: 'blur'}
            ],

            legalpersonPerson: [
              {max: 50, message: this.language['common.lengthUnder']  + '50', trigger: 'blur'}
            ],
            address: [
              {max: 300, message: this.language['common.lengthUnder']  + '300', trigger: 'blur'}
            ],
            socialCreditCode:[
              {validator: this.validateSocialCreditCode},
              {max: 300, message: this.language['common.lengthUnder']  + '300', trigger: 'blur'}
            ],
            phone: [
              {validator: this.validatePhone},
              {max: 45, message: this.language['common.lengthUnder']  + '45', trigger: 'blur'}
            ],
            telephone: [
              {max: 45, message: this.language['common.lengthUnder']  + '45', trigger: 'blur'}
            ],

            remark: [
              { required: false, message: this.language['common.pleaseInput']+this.language['basedata.remark']},
            ],
          }
        }
      },
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,this.model.id,languagelist);
      },
      languageOk(map){
        if(map){
          if(map.dataColumn == 'legalpersonName'){
            this.nameLanguages = map.languagelist;
          }else if(map.dataColumn == 'legalpersonPerson'){
            this.legalpersonPersonLanguages = map.languagelist;
          }else if(map.dataColumn == 'address'){
            this.addressLanguages =  map.languagelist;
          }
        }
      },
      initLanguagetemp(dataTable,dataColumn,dataId){
        getAction("/sys/syslanguagedata/querylistby", {applicationCode:"platform",dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=> {
          if (res.success) {
            if(dataColumn == 'legalpersonName'){
              this.nameLanguages = res.result;
            }else if(dataColumn == 'legalpersonPerson'){
              this.legalpersonPersonLanguages = res.result;
            }else if(dataColumn == 'address'){
              this.addressLanguages =  res.result;
            }
          }
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        this.initLanguagetemp('EpBdPerson','legalpersonName',this.model.id);
        this.initLanguagetemp('EpBdPerson','legalpersonPerson',this.model.id);
        this.initLanguagetemp('EpBdPerson','address',this.model.id);
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                let list = [];
                this.nameLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                  list.push(item);
                })
                this.legalpersonPersonLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                  list.push(item);
                })
                this.addressLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                  list.push(item);
                })
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",list,"post").then((res)=>{
                  if(res.success){
                    that.$message.success(res.message);
                    that.$emit('ok');
                  }
                })
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      validatePhone(rule, value, callback) {
        let that = this
        if (!value) {
          callback()
        } else {
          if (new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)) {
            callback()
          } else {
            callback(this.language['warning.phoneNumberIncorrect'])
          }
        }
      },
      validateSocialCreditCode(rule, value, callback){
        var params = {
          tableName: 'ep_bd_legalperson',
          fieldName: 'social_credit_code',
          fieldVal: value?value:"",
          dataId: this.model.id
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(this.language['legalperson.socialCreditCode']+this.language['common.alreadyExists'])
          }
        })
      },
    }
  }
</script>